import moment from 'moment';

import {ChatFileUpload} from 'llm/chat-library/ChatLibraryTypes';
import * as Net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface CreateDataCaptureAssistantChatResponse {
  chatId: string;
}

/**
 * Create a new chat object on the backend. This should be run on first meaningful
 * user action (e.g. sending a message).
 */
export function createDataCaptureAssistantChat(): Promise<CreateDataCaptureAssistantChatResponse> {
  return Net.postJSONPromise({
    url: '/1/api/llm/data-capture-assistant/chats',
  });
}

/**
 * Run the data capture assistant for the given chat, processing the given message
 * as a new user message.
 */
export async function runDataCaptureAssistantWithoutPolling(
  chatSessionId: string,
  message: string,
  fileUploads: Array<ChatFileUpload>
): Promise<{status_url: string}> {
  return await Net.postJSONPromise({
    url: `/1/api/llm/data-capture-assistant/chats/${chatSessionId}:run`,
    data: {message, fileUploads, currentDate: getCurrentDate()},
  });
}

/**
 * Run the data capture assistant for the given chat, processing the given message
 * as a new user message.
 */
export async function runDataCaptureAssistant(
  chatSessionId: string,
  message: string,
  fileUploads: Array<ChatFileUpload>
): Promise<void> {
  await TaskRunner.postJSONPromise({
    url: `/1/api/llm/data-capture-assistant/chats/${chatSessionId}:run`,
    data: {message, fileUploads, currentDate: getCurrentDate()},
  });
}

function getCurrentDate(): string {
  return moment().format('YYYY-MM-DD');
}
